<app-lead-time-row [entityLeadTime]="entityLeadTime()" [configurationLeadTime]="configurationLeadTime()">
</app-lead-time-row>
@if (skus() && sfrEntries()) {
  <div class="skuTableWrapper">
    @if (skus()) {
      <table class="alternateColors reportTable">
        @for (sku of skus(); track sku) {
          <tr [class.overridden]="isOverridden(sku)">
            <td class="tableCell">{{ sku.description }}</td>
            <td class="tableCell rightAligned">{{ getSkuPrice(sku) | currency: 'USD' }}</td>
          </tr>
        }
        @for (sfr of sfrEntries(); track sfr) {
          <tr>
            <td class="tableCell">
              <input class="sfrIgnoreCheckbox" type="checkbox" [checked]="!sfr.ignore" (change)="ignoreFlagChanged(sfr)"
                id="{{sfr.sfrNumber + 'ignoreCheckbox'}}">
              <label for="{{sfr.sfrNumber + 'ignoreCheckbox'}}">{{ sfr.sfrNumber + ' ' + sfr.description }}</label>
            </td>
            <td class="tableCell rightAligned">{{ getSfrPrice(sfr) | currency: 'USD' }}</td>
          </tr>
        }
      </table>
    }
  </div>
}
@if (skus() && sfrEntries()) {
  <div class="skuFooter">
    <span class="spacer"></span>
    <label class="totalPriceLabel">{{ 'Total Price: ' + (getTotalPrice() | currency: 'USD') }}</label>
  </div>
}
